<div *ngIf="loading" class="flex justify-content-center align-items-center p-4">
  <p-progressSpinner strokeWidth="4" styleClass="w-3rem h-3rem" />
</div>

<div *ngIf="!loading" class="flex flex-column">
  <!-- Productos -->
  <div class="mb-4">
    <h4 class="mt-0 mb-2">Productos</h4>
    <p-table [value]="mappingProducts" [tableStyle]="{ 'min-width': '40rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>Campo origen (Syncwall)</th>
          <th>Campo destino</th>
          <th style="width: 3rem"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-i="rowIndex">
        <tr>
          <td>
            <p-dropdown
              [options]="toFieldOptions(productFields)"
              [(ngModel)]="mappingProducts[i].sourceField"
              [editable]="true"
              appendTo="body"
              placeholder="Campo origen"
              styleClass="w-full"
            />
          </td>
          <td>
            <p-dropdown
              [options]="toFieldOptions(productFields)"
              [(ngModel)]="mappingProducts[i].targetField"
              [editable]="true"
              appendTo="body"
              placeholder="Campo destino"
              styleClass="w-full"
            />
          </td>
          <td>
            <p-button
              icon="pi pi-trash"
              severity="danger"
              [text]="true"
              (click)="removeProductMapping(i)"
            />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center text-color-secondary">Sin reglas de mapping</td>
        </tr>
      </ng-template>
    </p-table>
    <p-button
      label="Añadir regla"
      icon="pi pi-plus"
      [text]="true"
      size="small"
      class="mt-1"
      (click)="addProductMapping()"
    />
  </div>

  <!-- Categorías -->
  <div class="mb-4">
    <h4 class="mt-0 mb-2">Categorías</h4>
    <p-table [value]="mappingCategories" [tableStyle]="{ 'min-width': '40rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>Campo origen (Syncwall)</th>
          <th>Campo destino</th>
          <th style="width: 3rem"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-i="rowIndex">
        <tr>
          <td>
            <p-dropdown
              [options]="toFieldOptions(categoryFields)"
              [(ngModel)]="mappingCategories[i].sourceField"
              [editable]="true"
              appendTo="body"
              placeholder="Campo origen"
              styleClass="w-full"
            />
          </td>
          <td>
            <p-dropdown
              [options]="toFieldOptions(categoryFields)"
              [(ngModel)]="mappingCategories[i].targetField"
              [editable]="true"
              appendTo="body"
              placeholder="Campo destino"
              styleClass="w-full"
            />
          </td>
          <td>
            <p-button
              icon="pi pi-trash"
              severity="danger"
              [text]="true"
              (click)="removeCategoryMapping(i)"
            />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center text-color-secondary">Sin reglas de mapping</td>
        </tr>
      </ng-template>
    </p-table>
    <p-button
      label="Añadir regla"
      icon="pi pi-plus"
      [text]="true"
      size="small"
      class="mt-1"
      (click)="addCategoryMapping()"
    />
  </div>

  <div class="mt-auto pt-3">
    <p-button
      label="Guardar mapping"
      icon="pi pi-save"
      (click)="save()"
      [loading]="saving"
    />
  </div>
</div>
